"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/AuthFrame/Callout.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);
var _icons = require('./icons');








// An inline error next to the action it is about: the sentence, an optional
// line of help, and the next step as chip buttons.
const Callout = ({ message, detail, actions, className }) => (
  _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'auth-callout', className), role: "alert", __self: this, __source: {fileName: _jsxFileName, lineNumber: 16}}
    , _react2.default.createElement('div', { className: "auth-callout--msg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 17}}
      , _react2.default.createElement(_icons.AlertIcon, { className: "auth-callout--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 18}} )
      , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 19}},  message )
    )
    ,  detail && _react2.default.createElement('p', { className: "auth-callout--detail", __self: this, __source: {fileName: _jsxFileName, lineNumber: 21}},  detail ) 
    ,  actions && _react2.default.createElement('div', { className: "auth-callout--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 22}},  actions ) 
  )
)

exports. default = Callout
